<app-overlay />
<gc-modal
  [headerTitle]="
    'reportInput.errorPreventionModal.undoSelfInspectionQuestion' | translate
  "
  [primaryButtonText]="
    'reportInput.errorPreventionModal.undoSelfInspection' | translate
  "
  [primaryButtonVariant]="'danger'"
  [secondaryButtonText]="'reportInput.errorPreventionModal.cancel' | translate"
  (closeModal)="cancel.emit()"
  (primaryButtonClicked)="proceed.emit()"
  (secondaryButtonClicked)="cancel.emit()"
>
  <gc-text>{{ 'reportInput.errorPreventionModal.text' | translate }}</gc-text>
</gc-modal>
